import { render, staticRenderFns } from "./ModalDisagree.vue?vue&type=template&id=2685b142&scoped=true"
import script from "./ModalDisagree.vue?vue&type=script&lang=js"
export * from "./ModalDisagree.vue?vue&type=script&lang=js"
import style0 from "./ModalDisagree.vue?vue&type=style&index=0&id=2685b142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2685b142",
  null
  
)

export default component.exports